import { BaseContainerModel } from "../../base-container.model";
import { bl_wf_project_notification_subscription_login_link_RowClass } from "../../../dbschema/bl_wf_project_notification_subscription_login_link.model";

export class WfProjectNotificationSubscriptionLoginLinkContainerModel extends BaseContainerModel {
  bl_wf_project_notification_subscription_login_link: bl_wf_project_notification_subscription_login_link_RowClass = new bl_wf_project_notification_subscription_login_link_RowClass();
}
